import { MessageType } from "../lib/types";
import Logger from '../../js/lib/logger';

class MessageBar extends HTMLElement {
  #NAME = 'MessageBar';
  #svgIcon: HTMLElement;
  #span: HTMLSpanElement;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.innerHTML = `
      <svg-icon icon="info" size="large"></svg-icon>
      <span><span>
    `;
    this.#svgIcon = this.querySelector('svg-icon') as HTMLElement;
    this.#span = this.querySelector('span') as  HTMLSpanElement;
  }

  static get observedAttributes(): string[] {
    return ['data-type', 'data-show'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    Logger.info(`${this.#NAME} > attributeChangedCallback > ${name} = ${newValue}`);
    if (name === 'data-type') {
      this.#svgIcon.setAttribute('icon', newValue as MessageType === 'tip'? 'info' : 'error');
      switch (newValue as MessageType) {
        case 'tip':
          this.#span.innerHTML = 'Tip: Drag the edges of any insert to resize and fill missing gaps in your grid';
          break;

        case 'overlap':
          this.#span.innerHTML = 'Elements on the grid can not overlap. Spacing resolved automatically.';
          break;

        case 'duplicate':
          this.#span.innerHTML = 'There is not enough empty space on your grid to duplicate this element. Try resizing the inserts.';
          break;

        case 'empty spaces':
          this.#span.innerHTML = `
            There are empty spaces on your grid. <a href="#help" class="how-to-link">Click here for</a> directions to resolve empty space.
          `;
          break;

        case 'rotate':
          this.#span.innerHTML = 'There is not enough empty space on your grid to rotate this element.';
          break;

        case 'add':
          this.#span.innerHTML = 'There is not enough empty space on your grid to add this element. Try resizing the inserts.';
          break;

        case 'cushion':
          this.#span.innerHTML = 'Ring Cushion Inserts are not resizable.';
          break;

        case 'pillow':
          this.#span.innerHTML = 'Watch Pillow Inserts are not resizable.';
          break;
      
        default:
          break;
      }
    }
  }
}

customElements.define('message-bar', MessageBar);